import React, {useRef} from 'react'
import NavigationPanelReorderGroup from "../../../navigation/components/reorder-group/reorder-group"
import NavigationStructure from "../../../../core/model2/navigation/navigation-structure"
import Navigation_Separator from "../../../navigation/buttons/separator"
import ErrorBoundary from "../../../../core/error-boundary"
import NavigationSection from "../../../../core/model2/navigation/navigation-section"
import {NavigationButtonTypeClass} from "../../../navigation/@const";
import Navigation_ButtonSpace from "../../../navigation/buttons/generic-space";

type Props = {
    navigationStructure         : NavigationStructure
    onDragNavigationSectionsEnd : callback
    className?                  : string
    navWidth                    : number
}

// const debug = "NavigationUser"
const debug = false

export default function NavigationPanel_UserAsana(props: Props) {

    const leftSectionRef    = useRef<HTMLDivElement>(null)
    debug && console.log(debug, "Render()")

    // extract home section, it is rendered separately and should not present among reorderable items
    const homeSection   = gd.spaces.home.navigation

    // const workspaces= props.navigationStructure.workspaces
    const views         = _.filter(props.navigationStructure.views, (navigationSection: NavigationSection) => {
        return !navigationSection.isInMore
    })

    const more          = props.navigationStructure.more
    const quickAdd      = props.navigationStructure.quickAdd

    // it can be undefined when chat disabled...
    // const chat      = props.navigationStructure.chat
    const chat          = gd.spaces.chats.navigation

    const showViews     = views.length > 0

    const onReorder = (navigationSections: NavigationSection[]) => {
        debug && console.log(debug, "onReorder", navigationSections)

        gd.spaces.saveSpacesOrder(navigationSections)
    }

    const onViewsReorder = (navigationSections: NavigationSection[]) => {
        debug && console.log(debug, "onViewsReorder", navigationSections)

        props.onDragNavigationSectionsEnd(1, navigationSections)
    }

    return (
        <>
            <div ref={leftSectionRef} className="top">
                <div className="top-container">

                    {/*<NavigationLogo/>*/}

                    <ErrorBoundary>

                        <Navigation_ButtonSpace className={NavigationButtonTypeClass.IS_TAB} space={gd.spaces.home} />

                        <NavigationPanelReorderGroup sections={gd.spaces.navigationPanelTopSpacesAsNavigations}
                                                     onDragEnd={onReorder}/>

                        <Navigation_Separator/>

                        {showViews &&
                            <>
                                <NavigationPanelReorderGroup sections={views}
                                                             onDragEnd={onViewsReorder}/>

                                <Navigation_Separator/>
                            </>
                        }

                        <more.renderComponent section={more}/>


                    </ErrorBoundary>
                </div>
            </div>

            <>
                <div className="bottom m-b-20">

                    <quickAdd.renderComponent
                        section={quickAdd}
                        className="quick-add-action m-b-8"
                    />


                    {chat &&
                        <chat.renderComponent className={NavigationButtonTypeClass.IS_TAB}
                                              section={chat}/>}

                    {/*<Navigation_MyAccountBtn/>*/}
                </div>
            </>

        </>
    )
}
